import styled from 'styled-components';

export const OverflowTooltipText = styled.div`
  hyphens: auto;
  word-break: break-word;
`;
